export const RESET = 'EXSBVATRATE_UPDATE_RESET'
export const SET_ERROR = 'EXSBVATRATE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBVATRATE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBVATRATE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBVATRATE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBVATRATE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBVATRATE_UPDATE_UPDATE_RETRIEVED'
